import { ReactNode, useRef, useState } from 'react'
import { Transition } from 'react-transition-group'
import { useEffectOnMount } from 'builder/hooks/useEffectOnMount'

import * as Styles from './styles'

type Props = {
  timeout: number
  children: ReactNode
}

export const HorizontalTransitionFade = ({ timeout, children, ...props }: Props) => {
  const [isMounted, setIsMounted] = useState(false)
  const transitionRef = useRef(null)

  useEffectOnMount(() => {
    setIsMounted(true)
  })

  return (
    <Transition in={isMounted} timeout={timeout} nodeRef={transitionRef}>
      {state => (
        <Styles.Wrapper transitionState={state} {...props} ref={transitionRef}>
          {children}
        </Styles.Wrapper>
      )}
    </Transition>
  )
}
